export default __webpack_public_path__ + "static/media/SMILES-upload-template.e74ea6ef.csv";